import { css } from '@emotion/react';
import { themed, margins, flex, unit } from '@spotnana/blocks/src/utils/styling';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const payment_method_disclaimer = themed(
  ({ palette }) => css`
    border-bottom: solid 1px ${palette.border.light};
    font-size: 14px;
    line-height: 20px;
    color: ${palette.text.secondary};
  `,
);
export const card = themed(
  ({ palette }) =>
    css`
      border-radius: ${palette.border.radiusRegular} !important;
    `,
);

export const payment_element = themed(
  ({ fontWeight }) => css`
    ${paddings.y.comfortable}
    ${paddings.x.tight}
    .BlocksRadio-root {
      ${flex.align.center}
    }
    .BlocksRadio-label {
      font-weight: ${fontWeight.w600};
    }
  `,
);

export const direct_billing_instruction_title = css`
  ${margins.yb.half}
`;

export const info_text = css`
  ${flex.init}
  ${flex.align.center}
  ${paddings.x.tight}
  gap: ${unit(0.5)};
`;

export const hold_booking_payment_message = css`
  ${flex.init}
  ${flex.align.center}
  ${paddings.yt.compact}
  ${paddings.x.compact}
  gap: 8px;
`;

export const payment_methods_register_disclaimer = themed(
  ({ palette }) =>
    css`
      ${paddings.x.extraCozy}
      ${paddings.y.extraCozy}
      border: 1px solid ${palette.border.light};
      border-radius: ${unit(0.75)};
      background-color: ${palette.surface.base};
    `,
);
